export default {
  scheduled_order: 'Geplanter Auftrag',
  show_more: 'Mehr anzeigen',
  show_less: 'Weniger anzeigen',
  schedule_order: 'Weiter',
};
